<template>
  <div :class="{ telemetre: !noClass }">
    <div>
      <span v-if="measure_target_error_state == 0"
        >{{ measure_target_distance }} m</span
      >
      <span v-else>{{ measure_target_error_state_text }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "TelemetreLaser_affichage",
  props: {
    config: Object,
    noClass: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {};
  },
  computed: {
    measure_target_distance() {
      return (
        this.config?.drone?.status[this.config?.camera?.payload_index]
          ?.measure_target_distance ?? 0
      ).toFixed(2);
    },

    measure_target_error_state() {
      return this.config?.drone?.status[this.config?.camera?.payload_index]
        ?.measure_target_error_state;
    },

    measure_target_error_state_text() {
      let error_state = this.measure_target_error_state;

      if (error_state == 1) {
        return this.$e("Erreur : Cible trop proche");
      } else if (error_state == 2) {
        return this.$e("Erreur : Cible trop loin");
      } else if (error_state == 3) {
        return this.$e("Erreur : Aucun signal");
      }
      return this.$e("Erreur inconnue");
    },
  },
};
</script>
